import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CellText, CellLink, CellThumbnail, CellAssetsSelect, CellDuration, CellStatus, CellTextDuration, } from 'app/components/Table/Cells';
import { createActivity, deleteActivity, updateActivity } from 'app/store/reducers/reduxActivities';
import { uniq, filter, uniqBy } from 'lodash';
import { router as routerAssetDetail } from 'app/containers/Assets/AssetDetail/router';
import { checkTaskPerms, checkMyTasksPerms, checkTakePerms } from 'app/pages/Project/Tasks/checkPerms.js';
import moment from 'moment';
import { getLastTakeFromTask } from 'app/pages/Project/ProductionManagement/FollowUp/utils.jsx';
import { permission } from 'app/containers/Permissions';
import { progressionStatusFilter } from 'app/core/utils/optionsProgressionStatus';
import { tableId as myTaskTableId } from 'app/pages/MyTasks/MyTasks';
import { updateTake } from 'app/store/reducers/takes';
import CellDurationTotal from 'app/pages/MyHours/CellDurationTotal/CellDurationTotal';
import { colors } from 'app/styles/colors.js';
import { durationStr } from 'app/components/Duration/Duration';
export default ({ dispatch, history, defaultActions, projects, progressionStatus, selectedDays, user, addTimeOnSelection, addCustomActivity, findActivity, addLeave, userLeaves, getLeaveDayPart, formatView, startDateString, endDateString, userTaskActivities, activities, startDate, endDate, getActivitiesSumByDate, }) => [
    {
        Header: 'Task',
        id: 'tasks',
        columns: [
            CellLink({
                Header: 'Asset',
                id: 'asset',
                accessor: 'assetInst.name',
                fixed: 'left',
                fixable: false,
                hiddenable: true,
                readOnly: true,
                showRemoved: true,
                actions: defaultActions,
                sortingKey: 'asset__name',
                onClick: (row) => routerAssetDetail.goTo('index', { assetId: row.original.assetInst.id }, { rightPanel: true }),
            }),
            CellText({
                Header: 'Step',
                id: 'step',
                fixed: 'left',
                hiddenable: true,
                fixable: true,
                readOnly: true,
                actions: defaultActions,
                accessor: 'stepInst.name',
                sortingKey: 'step__name',
                width: 100,
            }),
            CellThumbnail({
                Header: 'Thumbnail',
                accessor: 'assetInst.thumbnailInst',
                id: 'thumbnail',
                fixed: 'left',
                fixable: true,
                hiddenable: true,
                width: 90,
                readOnly: false,
                actions: (instance, cell) => { var _a, _b; return checkTaskPerms(['edit', 'delete', ...defaultActions(instance, cell)], (_b = (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.assetInst) === null || _b === void 0 ? void 0 : _b.project); },
                save: {
                    resource: 'assets',
                    formatData: (item, value, cell, instance, type) => {
                        if (type === 'delete') {
                            return {
                                id: item.taskInst && item.taskInst.assetInst && item.taskInst.assetInst.id,
                                thumbnail: null,
                            };
                        }
                        return {
                            id: item.taskInst && item.taskInst.assetInst && item.taskInst.assetInst.id,
                            thumbnail: typeof value === 'string' ? value : value === null || value === void 0 ? void 0 : value.id,
                        };
                    },
                },
            }),
            CellLink({
                Header: 'Project',
                accessor: (task) => {
                    if (!task || !task.assetInst)
                        return '';
                    const project = projects.find((pj) => pj.id === task.assetInst.project);
                    return project && project.name;
                },
                hiddenable: true,
                fixable: true,
                fixed: 'left',
                readOnly: true,
                actions: defaultActions,
                id: 'project',
                onClick: (row) => history.push(`/projects/${row.original.assetInst.project}`),
                sortingKey: 'asset__project__name',
            }),
            CellText({
                Header: 'Start date',
                id: 'startDate',
                fixed: 'left',
                hiddenable: true,
                fixable: true,
                inputProps: {
                    type: 'date',
                },
                readOnly: true,
                actions: defaultActions,
                accessor: (task) => moment(task.startDate).format('YYYY-MM-DD'),
                width: 100,
            }),
            CellText({
                Header: 'End date',
                id: 'endDate',
                fixed: 'left',
                hiddenable: true,
                fixable: true,
                inputProps: {
                    type: 'date',
                },
                readOnly: true,
                actions: defaultActions,
                accessor: (task) => moment(task.endDate).format('YYYY-MM-DD'),
                width: 100,
            }),
            CellAssetsSelect({
                Header: 'Asset parent',
                fixable: true,
                placeholder: '',
                hiddenable: true,
                fixed: 'left',
                readOnly: true,
                showIcon: true,
                id: 'asset__parent__uuid',
                width: 170,
                actions: defaultActions,
                accessor: 'assetParentInst',
                sortingKey: 'asset__parent__name',
            }),
            CellStatus({
                Header: 'Status',
                id: 'status',
                fixable: true,
                fixed: 'left',
                hiddenable: true,
                readOnly: false,
                sortingKey: 'status__name',
                accessor: (data) => {
                    const lastTake = getLastTakeFromTask(data);
                    return lastTake.status;
                },
                isHashed: (cell) => {
                    const lastTake = getLastTakeFromTask(cell.row.original);
                    if (lastTake) {
                        const { number, statusInst = {} } = lastTake;
                        return number === 1 && statusInst.statusType === 0;
                    }
                    return false;
                },
                progressionStatus: progressionStatus || {},
                width: 160,
                componentProps: {
                    disabledOptions: !permission(['my tasks___can close a take'])
                        ? progressionStatusFilter(progressionStatus || {}, 'with', ['new', 'close', 'retake']).map((ps) => ps.id)
                        : [],
                },
                actions: (instance, cell) => {
                    var _a, _b;
                    return uniq(checkMyTasksPerms(cell.row, ['edit', 'copy', 'past'], progressionStatus || {}, myTaskTableId, 'status', (_b = (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.assetInst) === null || _b === void 0 ? void 0 : _b.project)
                        .concat(checkTakePerms(['edit', 'copy', 'past']))
                        .concat(defaultActions(instance, cell)));
                },
                Total: () => _jsx("div", { className: "flex center bold", children: "Total per day" }),
                reduxSave: {
                    bulk: true,
                    reduxAction: (values) => dispatch(updateTake(values)),
                    getData: (data, newValue) => {
                        const lastTake = getLastTakeFromTask(data);
                        if (!lastTake)
                            return null;
                        return {
                            task: data.id,
                            id: lastTake.id,
                            status: newValue,
                        };
                    },
                },
            }),
        ],
    },
    {
        Header: 'Activities',
        id: 'activities',
        resizable: false,
        columns: selectedDays.map((date, index) => {
            const isFutureDay = new Date() < date.toDate();
            const isWeekend = [0, 6].includes(date.day());
            const isCurrentDay = moment().isSame(date, 'day');
            const dateString = date.format('YYYY-MM-DD');
            return CellTextDuration({
                Header: '',
                headerSubLabel: (_jsxs("div", { children: [_jsx("div", { className: "fontSize12 normal", children: date.format('ddd') }), _jsx("p", { children: date.format('D') })] })),
                id: date.format('YYYY-MM-DD'),
                readOnly: false,
                resizable: false,
                draggable: false,
                noFilterOption: true,
                headerStyle: {
                    fontWeight: isCurrentDay ? 'bold' : undefined,
                    color: isCurrentDay ? '#ffffff' : undefined,
                    backgroundColor: isCurrentDay ? 'rgba(0,138,230)' : isWeekend ? 'rgba(0,0,0,0.03)' : undefined,
                },
                cellsStyle: {
                    backgroundColor: isWeekend || isFutureDay ? 'rgba(0,0,0,0.04)' : undefined,
                },
                accessor: (item) => {
                    if (!item)
                        return null;
                    const activity = findActivity(item.activitiesInst, dateString);
                    return activity || null;
                },
                durationProps: {
                    hide: { days: true },
                },
                textAlignment: index < 2
                    ? 'left'
                    : index === selectedDays.length - 1 || index === selectedDays.length - 2
                        ? 'right'
                        : 'center',
                actions: (instance, cell) => !isFutureDay
                    ? [
                        'edit',
                        'delete',
                        'copy',
                        'past',
                        'separator',
                        addTimeOnSelection(instance, cell),
                        addCustomActivity(instance, cell),
                        addLeave(instance, cell),
                        ...defaultActions(instance, cell),
                    ]
                    : ['delete', 'separator', ...defaultActions(instance, cell), 'separator', addLeave(instance, cell)],
                Total: (instance) => {
                    const activitiesByDate = getActivitiesSumByDate(dateString);
                    const dayLeave = userLeaves.find(({ startDate, endDate }) => {
                        if (!startDate && !endDate)
                            return;
                        const sd = moment(startDate).format('MM/DD/YYYY');
                        const ed = moment(endDate).format('MM/DD/YYYY');
                        return moment(dateString).isBetween(sd, ed, 'day', '[]');
                    });
                    let leaveType = getLeaveDayPart(dateString, dayLeave);
                    const leaveDuration = !leaveType ? 0 : leaveType === 'fullday' ? 28800 : 14400;
                    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { height: `calc(100% - ${leaveType ? 3 : 0}px)`, width: '100%' }, children: _jsx(CellDurationTotal, { duration: activitiesByDate.reduce((acc, activity) => acc + activity.duration, 0) + leaveDuration, dateISO: date.toISOString() }) }), leaveType ? (_jsx("div", { style: {
                                    height: '3px',
                                    width: leaveType === 'fullday' ? '100%' : '50%',
                                    marginLeft: leaveType === 'afternoon' ? '50%' : undefined,
                                    backgroundColor: colors.red,
                                } })) : null] }));
                },
                reduxSave: {
                    bulk: true,
                    reduxAction: (values) => {
                        const activitiesIdsToDelete = values.flatMap((value) => value.activitiesToDelete).filter((_) => _);
                        const activitiesToCreate = values.flatMap((value) => value.toCreate).filter((_) => _);
                        const activitiesToUpdate = values.flatMap((value) => value.toUpdate).filter((_) => _);
                        const promises = [
                            activitiesIdsToDelete.length &&
                                dispatch(deleteActivity({ activitiesIds: activitiesIdsToDelete, isFromMyHours: true })),
                            activitiesToCreate.length &&
                                dispatch(createActivity({ createdActivities: activitiesToCreate, isFromMyHours: true })),
                            activitiesToUpdate.length &&
                                dispatch(updateActivity({ activities: activitiesToUpdate, isFromMyHours: true })),
                        ];
                        return Promise.all(promises);
                    },
                    getData: (data, newValue, type) => {
                        const activity = findActivity(data.activitiesInst, dateString);
                        const { duration, text } = newValue || { duration: 0, text: '' };
                        if (type === 'delete' || duration < 1) {
                            return { activitiesToDelete: [activity.id] };
                        }
                        if (!activity) {
                            return {
                                toCreate: {
                                    duration,
                                    task: data.id,
                                    date: dateString,
                                    user: user.asset,
                                    comment: text,
                                },
                            };
                        }
                        return {
                            toUpdate: {
                                id: activity.id,
                                duration,
                                comment: text,
                            },
                        };
                    },
                },
                width: formatView === 'month' ? 60 : 120,
            });
        }),
    },
    {
        Header: '',
        id: 'totalPerTaskGrp',
        columns: [
            CellDuration({
                Header: 'Total per task',
                id: 'totalDurationForWeek',
                fixed: 'right',
                readOnly: true,
                accessor: (item) => {
                    const duration = filter(item.activitiesInst, (activity) => {
                        return (activity.date >= startDateString &&
                            activity.date <= endDateString &&
                            user.asset === activity.user &&
                            !activity.activityType);
                    }).reduce((acc, activity) => activity.duration + acc, 0);
                    return duration;
                },
                durationProps: {
                    hide: { days: true },
                },
                actions: (instance, cell) => defaultActions(instance, cell),
                Total: (footer) => {
                    const activitiesDuration = uniqBy([...userTaskActivities, ...activities], 'id')
                        .filter((activity) => {
                        const dateActivity = new Date(activity.date);
                        return (dateActivity >= startDate.toDate() && dateActivity <= endDate.toDate() && user.asset === activity.user);
                    })
                        .reduce((acc, activity) => activity.duration + acc, 0);
                    const duration = durationStr(activitiesDuration, 24, { days: true });
                    return _jsx("div", { className: "flex center alignCenter bold fullHeight", children: duration });
                },
            }),
        ],
    },
];
